var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegBelowTheFoldL(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0H6.51163C2.91535 0 0 2.65313 0 5.92593V74.0741C0 77.3469 2.91535 80 6.51163 80H133.488C137.085 80 140 77.3469 140 74.0741V5.92593C140 2.65313 137.085 0 133.488 0Z",
    fill: "#4F4C57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134 6H6V31H134V6Z",
    fill: "#625E70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.527 23H74.4683C75.4755 23 76 22.5206 76 21.6046V16.3954C76 15.4794 75.4755 15 74.4683 15H66.527C65.5245 15 65 15.4751 65 16.3954V21.6046C65 22.5206 65.5245 23 66.527 23ZM68.6295 19.0792C67.9936 19.0792 67.4691 18.5998 67.4691 18.0133C67.4691 17.4313 67.9936 16.9433 68.6295 16.9433C69.2607 16.9433 69.7806 17.4313 69.7806 18.0133C69.7806 18.5998 69.2607 19.0792 68.6295 19.0792ZM66.6012 22.1482C66.1788 22.1482 65.9236 21.9128 65.9236 21.519V21.1765L67.2325 20.1236C67.4366 19.9567 67.6409 19.8754 67.859 19.8754C68.0818 19.8754 68.3139 19.9609 68.5181 20.1279L69.3954 20.8598L71.5907 19.0621C71.8134 18.878 72.0641 18.7924 72.324 18.7924C72.5747 18.7924 72.8393 18.8823 73.0528 19.0706L75.0717 20.7913V21.5233C75.0717 21.9128 74.8071 22.1482 74.3988 22.1482H66.6012Z",
    fill: "#908CA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134 34H6V74H134V34Z",
    fill: "#625E70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7136 47H47.4345C46.5355 47 45.8066 47.6633 45.8066 48.4815C45.8066 49.2997 46.5355 49.963 47.4345 49.963H63.7136C64.6127 49.963 65.3415 49.2997 65.3415 48.4815C65.3415 47.6633 64.6127 47 63.7136 47Z",
    fill: "#908CA0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.089 52.9629H47.524C46.5755 52.9629 45.8066 53.6345 45.8066 54.4629C45.8066 55.2913 46.5755 55.9629 47.524 55.9629H123.089C124.038 55.9629 124.807 55.2913 124.807 54.4629C124.807 53.6345 124.038 52.9629 123.089 52.9629Z",
    fill: "#908CA0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7849 58.9629H46.8284C46.2641 58.9629 45.8066 59.6345 45.8066 60.4629C45.8066 61.2913 46.2641 61.9629 46.8284 61.9629H91.7849C92.3492 61.9629 92.8066 61.2913 92.8066 60.4629C92.8066 59.6345 92.3492 58.9629 91.7849 58.9629Z",
    fill: "#908CA0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7667 38H12.541V70H40.7667V38Z",
    fill: "#908CA0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegBelowTheFoldL);
export default __webpack_public_path__ + "static/media/icon-reg-below-the-fold-L.09ca9fab58841ee2303833e0cb8b187a.svg";
export { ForwardRef as ReactComponent };